// extracted by mini-css-extract-plugin
export default {"wrapper":"switcher_wrapper__2w1HV","slider":"switcher_slider__lkU03","disable":"switcher_disable__Amu3G","active":"switcher_active__1Yz2M"};